import { render, staticRenderFns } from "./ProofreadingProperNounExcludeDialog.vue?vue&type=template&id=c5c37dfe&scoped=true"
import script from "./ProofreadingProperNounExcludeDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingProperNounExcludeDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingProperNounExcludeDialog.vue?vue&type=style&index=0&id=c5c37dfe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c37dfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5c37dfe')) {
      api.createRecord('c5c37dfe', component.options)
    } else {
      api.reload('c5c37dfe', component.options)
    }
    module.hot.accept("./ProofreadingProperNounExcludeDialog.vue?vue&type=template&id=c5c37dfe&scoped=true", function () {
      api.rerender('c5c37dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/ProofreadingProperNounExcludeDialog.vue"
export default component.exports